import React, { useEffect, useState } from "react";
import {
  addItem,
  fetchCategories,
  getAttribute,
  getAttributeOptions,
  getBrands,
  getManufacturer,
} from "../Services/inventoryService";
import "../Style/AddItemModal.css";
import Select from "react-select";
import "../Style/Common.css";
import Footer from "../Footer/Footer";
import {
  IAddItemRequest,
  IGetAttributeResponse,
} from "../Interfaces/IInventory";
import TextField from "@mui/material/TextField/TextField";
import TextareaAutosize from "@mui/material/TextareaAutosize/TextareaAutosize";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Swal from "sweetalert2";
import {
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Button,
  Collapse,
  Checkbox,
  Box,
  Container,
  Tooltip,
  CircularProgress,
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import dayjs from "dayjs";
import { uomOptions } from "../Services/CommonService";
import { useSnackbar } from "notistack";
import {
  MSG_BATCH_NUMBER_MUST_BE_POSITIVE,
  MSG_BRAND_REQUIRED,
  MSG_CATEGORY_REQUIRED,
  MSG_COST_PRICE_MUST_BE_POSITIVE,
  MSG_COST_PRICE_REQUIRED,
  MSG_DISCOUNT_RATE_MUST_BE_POSITIVE,
  MSG_ITEM_ADDED,
  MSG_ITEM_NAME_REQUIRED,
  MSG_LOT_NUMBER_MUST_BE_POSITIVE,
  MSG_MANUFACTURER_REQUIRED,
  MSG_QUANTITY_MUST_BE_POSITIVE,
  MSG_REORDER_POINT_MUST_BE_POSITIVE,
  MSG_SELECT_ATTRIBUTE_OPTION,
  MSG_SELLING_PRICE_MUST_BE_POSITIVE,
  MSG_SELLING_PRICE_REQUIRED,
  MSG_STOCK_QUANTITY_MUST_BE_POSITIVE,
  MSG_STOCK_QUANTITY_REQUIRED,
  MSG_UOM_REQUIRED,
} from "../Constants/MessageConstant";
import {
  LBL_TOOLTIP_HELP,
  LBL_COST_PRICE,
  LBL_HSN,
  LBL_ITEM_NAME,
  LBL_ITEM_TYPE,
  LBL_ITEM_TYPE_INVENTORY,
  LBL_ITEM_TYPE_NONINVENTORY,
  LBL_SELLING_PRICE,
  LBL_TYPE_GOODS,
  LBL_TYPE_SERVICE,
  LBL_ADD_ITEM,
  LBL_ADD_ATTRIBUTE,
  PLACEHOLDER_SELECT_OPTIONS,
  PLACEHOLDER_SELECT_ATTRIBUTE_NAME,
  LBL_CREATE_ATTRIBUTES,
  PLACEHOLDER_SELECT_MANUFACTURER,
  PLACEHOLDER_SELECT_BRAND,
  PLACEHOLDER_SELECT_CATEGORY,
  LBL_NON_TAXABLE,
  LBL_TAXABLE,
  LBL_TAX_PREFERENCE,
  LBL_DISCOUNT_RATE,
  LBL_LOT_NUMBER,
  LBL_BATCH_NUMBER,
  LBL_UPC,
  LBL_EXPIRY_DATE,
  LBL_SKU,
  LBL_WAREHOUSE,
  LBL_REORDER_POINT,
  LBL_OTHER_DETAILS,
  LBL_DESCRIPTION,
  LBL_STOCK_QUANTITY,
  PLACEHOLDER_SELECT_UOM,
} from "../Constants/LabelConstants";

// Define the type for an inventory item
interface Item {
  id: number;
  type: "Goods" | "Service";
  itemName: string;
  sku: string; // Stock keeping unit
  costPrice: number | string;
  sellingPrice: number | string;
  upc: string; // Universal Product code
  ian: string; // Indian Article number
  hsn: string; // International standard book number
  reorderPoint: number | string;
  desc: string;
  brand: string;
  category: string;
  manufacturer: string;
  itemType: "Inventory" | "NonInventory";
  taxable: boolean;
  createAttributes: boolean;
  attributes: { type: string; value: string }[];
  uom?: string;
}
// Props for the InventoryItem component
interface InventoryItemProps {
  item: Item;
  onDelete: (id: number) => void;
  onUpdate: (updatedItem: Item) => void;
}
// Define the type for options
type OptionType = {
  id: string;
  label: string;
};
// AddItemModal component
const AddItemModal: React.FC = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [categoryOptions, setCategoryOptions] = useState<OptionType[]>([]);
  const [brandOptions, setBrandOptions] = useState<OptionType[]>([]);

  const [costPriceError, setCostPriceError] = useState(false);
  const [itemNameError, setItemNameError] = useState(false);
  const [sellingPriceError, setSellingPriceError] = useState(false);
  const [quantityError, setQuantityError] = useState(false);
  const [uomError, setUomError] = useState(false);

  const [manufacturerOptions, setManufacturerOptions] = useState<OptionType[]>(
    []
  );
  const orgId = localStorage.getItem("orgId") || "";
  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState<IAddItemRequest[]>([]);
  const [availableAttributes, setAvailableAttributes] = useState<
    { id: string; name: string }[]
  >([]);
  const [newItem, setNewItem] = useState<Omit<IAddItemRequest, "itemId">>({
    name: "",
    brandId: "",
    categoryId: "",
    categoryName: "",
    manufacturerId: "",
    hsn: "",
    taxId: 0,
    sku: "",
    upc: "",
    ian: "",
    itemTypeId: "",
    unit: "",
    costPrice: "",
    sellingPrice: "",
    quantity: "",
    isActive: true,
    createdDate: new Date().toISOString(),
    updatedDate: new Date().toISOString(),
    updatedBy: "",
    createdBy: "admin_user",
    createdByIp: "",
    updatedByIp: "",
    itemAttribute: [],
    orgId: "",
    taxable: true,
    createAttributes: false,
    type: "Goods",
    reorderPoint: "",
    desc: "",
    itemType: "Inventory",
    uom: "",
    warehouse: "",
    warehouseId: 1, // Add this line
    //stockQuantity: 0,
    discountRate: 0,
    batchNumber: 0,
    expiryDate: "",
    lotNumber: 0,

    additionalFieldsOpen: false,
  });
  const [saving, setSaving] = useState(false);
  // Fetch attributes from API
  useEffect(() => {
    const fetchAttributes = async () => {
      try {
        const response = await getAttribute();
        if (Array.isArray(response)) {
          setAvailableAttributes(
            response.map((item) => ({ id: item.attributeId, name: item.name }))
          );
        } else {
          console.error("Unexpected response format:", response);
        }
      } catch (error) {
        console.error("Failed to fetch attributes:", error);
      }
    };
    const getCategories = async () => {
      try {
        const categories = await fetchCategories(orgId);
        const formattedOptions = categories.map(
          (category: { categoryId: any; categoryName: any }) => ({
            id: category.categoryId,
            label: category.categoryName,
          })
        );
        setCategoryOptions(formattedOptions);
      } catch (error) {
        console.error("Error loading categories:", error);
      } finally {
        setLoading(false);
      }
    };

    getCategories();
    fetchAttributes();
  }, []);
  const validateNewItem = (item: Omit<IAddItemRequest, "itemId">) => {
    const errors: string[] = [];

    // Check required fields
    if (!item.name) {
      errors.push(MSG_ITEM_NAME_REQUIRED);
    }
    if (!item.costPrice || Number(item.costPrice) <= 0) {
      errors.push(MSG_COST_PRICE_MUST_BE_POSITIVE);
    }
    if (!item.sellingPrice || Number(item.sellingPrice) <= 0) {
      errors.push(MSG_COST_PRICE_MUST_BE_POSITIVE);
    }
    if (!item.quantity || Number(item.quantity) < 0) {
      errors.push(MSG_QUANTITY_MUST_BE_POSITIVE);
    }
    if (!item.uom || item.uom.trim() === "") {
      errors.push(MSG_UOM_REQUIRED);
    }
    if (!item.categoryId) {
      errors.push(MSG_CATEGORY_REQUIRED);
    }
    // if (!item.brandId) {
    //   errors.push("Brand is required,");
    // }
    // if (!item.manufacturerId) {
    //   errors.push("Manufacturer is required.");
    // }

    return errors;
  };

  const handleAddItem = async () => {
    // Validate new item
    const validationErrors = validateNewItem(newItem);
    if (validationErrors.length > 0) {
      enqueueSnackbar(validationErrors.join("\n"), {
        variant: "error",
        autoHideDuration: 3000,
      });
      return; // Stop execution if there are validation errors
    }
    try {
      setSaving(true);
      const itemId = Date.now();
      const itemData = { itemId, ...newItem };
      const response = await addItem(itemData);
      if (response.success) {
        setItems([...items, itemData]);
        enqueueSnackbar(MSG_ITEM_ADDED, {
          variant: "success",
          autoHideDuration: 3000,
        });
        setNewItem({
          name: "",
          brandId: "",
          categoryId: "",
          manufacturerId: "",
          hsn: "",
          taxId: 0,
          sku: "",
          upc: "",
          ian: "",
          itemTypeId: "",
          unit: "",
          costPrice: "",
          sellingPrice: "",
          quantity: 0,
          isActive: true,
          createdDate: new Date().toISOString(),
          updatedDate: new Date().toISOString(),
          updatedBy: "",
          createdBy: "admin_user",
          createdByIp: "",
          updatedByIp: "",
          itemAttribute: [],
          orgId: "",
          taxable: true,
          createAttributes: false,
          type: "Goods",
          reorderPoint: 0,
          desc: "",
          itemType: "Inventory",
          uom: "kg",
          expiryDate: "",
          batchNumber: 0,
          lotNumber: 0,
          discountRate: 0,
          warehouseId: 1,
          warehouse: "",
        });
      } else {
        enqueueSnackbar(response.message, {
          variant: "error",
          autoHideDuration: 3000,
        });
      }
    } catch (error: any) {
      enqueueSnackbar(error.message, {
        variant: "error",
        autoHideDuration: 3000,
      });
    } finally {
      setSaving(false);
    }
  };

  const handleTaxableChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setNewItem({ ...newItem, taxable: e.target.value === "Taxable" });
  };

  const handleAttributesChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setNewItem({ ...newItem, createAttributes: !newItem.createAttributes });
  };

  // const handleAddAttribute = () => {
  //   setNewItem({
  //     ...newItem,
  //     itemAttribute: [
  //       ...newItem.itemAttribute,
  //       { itemId: 0, attribute: "Attribute", option: "", availableOptions: [] },
  //     ],
  //   });
  // };

  const handleAddAttribute = () => {
    if (newItem.itemAttribute.length > 0) {
      const lastAttribute =
        newItem.itemAttribute[newItem.itemAttribute.length - 1];

      if (!lastAttribute.attribute || !lastAttribute.option) {
        // Swal.fire({
        //   title: "Please select attribute and option",
        //   text: "You can't add next attribute without selecting current one",
        //   icon: "warning",
        //   confirmButtonText: "Ok",
        // });
        enqueueSnackbar(MSG_SELECT_ATTRIBUTE_OPTION, {
          variant: "warning",
          autoHideDuration: 3000,
        });

        return;
      }
    }

    setNewItem({
      ...newItem,
      itemAttribute: [
        ...newItem.itemAttribute,
        { itemId: 0, attribute: "Attribute", option: "", availableOptions: [] },
      ],
    });
  };

  // const handleAttributeOptionChange = async (
  //   index: number,
  //   field: "attribute" | "option",
  //   selectedOption: { value: string | number; label: string } | null
  // ) => {

  //   const updatedAttributes = [...newItem.itemAttribute];

  //   if (field === "attribute" && selectedOption) {
  //     updatedAttributes[index] = {
  //       ...updatedAttributes[index],
  //       attribute: selectedOption.value,
  //       option: null, // Reset option when the attribute changes
  //     };

  //     // Fetch new options for the selected attribute
  //     getAttributeOptions(selectedOption.value).then((response) => {
  //       const formattedOptions = response.map((opt: IGetAttributeResponse) => ({
  //         id: typeof opt.id === "string" ? Number(opt.id) : opt.id, // Handle string or number
  //         name: opt.name,
  //       }));
  //       setAvailableAttributesOption(formattedOptions);
  //     });
  //   }

  //   if (field === "option" && selectedOption) {
  //     updatedAttributes[index] = {
  //       ...updatedAttributes[index],
  //       option: selectedOption.value,
  //     };
  //   }

  //   setNewItem({ ...newItem, itemAttribute: updatedAttributes });
  // };

  const [errors, setErrors] = useState({
    category: false,
    brand: false,
    manufacturer: false,
  });
  const handleAttributeOptionChange = async (
    index: number,
    field: "attribute" | "option",
    selectedOption: { value: string | number; label: string } | null
  ) => {
    const updatedAttributes = [...newItem.itemAttribute];

    if (field === "attribute" && selectedOption) {
      const response = await getAttributeOptions(selectedOption.value);
      const formattedOptions = response.map((opt: IGetAttributeResponse) => ({
        id: typeof opt.id === "string" ? Number(opt.id) : opt.id,
        name: opt.name,
      }));

      updatedAttributes[index] = {
        ...updatedAttributes[index],
        attribute: selectedOption.value,
        option: null, // Reset option when the attribute changes
        availableOptions: formattedOptions, // Store specific options for this row
      };
    }

    if (field === "option" && selectedOption) {
      updatedAttributes[index] = {
        ...updatedAttributes[index],
        option: selectedOption.value,
      };
    }

    setNewItem({ ...newItem, itemAttribute: updatedAttributes });
  };

  // const handleCategoryBrandManufacturerChange = async (
  //   field: "category" | "brand" | "manufacturer",
  //   selectedOption: { id: string } | null
  // ) => {
  //   if (field === "category") {
  //     const categoryId = selectedOption?.id || "";
  //     const response = await getBrands(orgId, categoryId);
  //     const formattedOptions = response.map(
  //       (brands: { brandId: any; brandName: any }) => ({
  //         id: brands.brandId,
  //         label: brands.brandName,
  //       })
  //     );
  //     setBrandOptions(formattedOptions);
  //     setNewItem({
  //       ...newItem,
  //       categoryId: categoryId,
  //       brandId: null,
  //       manufacturerId: null,
  //     });
  //     setManufacturerOptions([]);
  //     // Remove error if category is selected.
  //     setErrors((prev) => ({ ...prev, category: categoryId === "" }));
  //   }
  //   if (field === "brand") {
  //     const brandId = selectedOption?.id || "";
  //     const response = await getManufacturer(orgId, brandId);
  //     const formattedOptions = response.map(
  //       (manufacturer: { manufacturerId: any; manufacturerName: any }) => ({
  //         id: manufacturer.manufacturerId,
  //         label: manufacturer.manufacturerName,
  //       })
  //     );
  //     setManufacturerOptions(formattedOptions);
  //     setNewItem({ ...newItem, brandId: brandId, manufacturerId: null });
  //     setErrors((prev) => ({ ...prev, brand: brandId === "" }));
  //   }
  //   if (field === "manufacturer") {
  //     const manufacturerId = selectedOption?.id || "";
  //     setNewItem({ ...newItem, manufacturerId: manufacturerId });
  //     setErrors((prev) => ({ ...prev, manufacturer: manufacturerId === "" }));
  //   }
  // };
  const handleCategoryBrandManufacturerChange = async (
    field: "category" | "brand" | "manufacturer",
    selectedOption: { id: string; label: string } | null
  ) => {
    try {
      if (field === "category") {
        const categoryId = selectedOption?.id || "";
        const categoryName = selectedOption?.label || "";
        let formattedOptions:
          | ((prevState: OptionType[]) => OptionType[])
          | { id: any; label: any }[] = [];

        try {
          const response = await getBrands(orgId, categoryId);
          if (Array.isArray(response)) {
            formattedOptions = response.map(
              (brands: { brandId: any; brandName: any }) => ({
                id: brands.brandId,
                label: brands.brandName,
              })
            );
          }
        } catch (error: any) {
          if (error.response?.status === 404) {
            console.warn("No brands found for this category.");
          } else {
            console.error("Error fetching brands:", error);
          }
        }

        setBrandOptions(formattedOptions);
        setNewItem({
          ...newItem,
          categoryId: categoryId,
          categoryName: categoryName,
          brandId: null,
          manufacturerId: null,
        });
        setManufacturerOptions([]);
        setErrors((prev) => ({ ...prev, category: categoryId === "" }));
      }

      if (field === "brand") {
        const brandId = selectedOption?.id || "";
        let formattedOptions:
          | { id: any; label: any }[]
          | ((prevState: OptionType[]) => OptionType[]) = [];

        try {
          const response = await getManufacturer(orgId, brandId);
          if (Array.isArray(response)) {
            formattedOptions = response.map(
              (manufacturer: {
                manufacturerId: any;
                manufacturerName: any;
              }) => ({
                id: manufacturer.manufacturerId,
                label: manufacturer.manufacturerName,
              })
            );
          }
        } catch (error: any) {
          if (error.response?.status === 404) {
            console.warn("No manufacturers found for this brand.");
          } else {
            console.error("Error fetching manufacturers:", error);
          }
        }

        setManufacturerOptions(formattedOptions);
        setNewItem({ ...newItem, brandId: brandId, manufacturerId: null });
        setErrors((prev) => ({ ...prev, brand: brandId === "" }));
      }

      if (field === "manufacturer") {
        const manufacturerId = selectedOption?.id || "";
        setNewItem({ ...newItem, manufacturerId: manufacturerId });
        setErrors((prev) => ({ ...prev, manufacturer: manufacturerId === "" }));
      }
    } catch (error) {
      console.error("Error in handleCategoryBrandManufacturerChange:", error);
    }
  };

  /**
   * Removes an attribute option at the given index from the attributes array
   * @param {number} idx The index of the attribute option to remove
   */
  const handleRemoveAttributeOption = (idx: number) => {
    const updatedAttributes = [...newItem.itemAttribute];
    updatedAttributes.splice(idx, 1);
    setNewItem({ ...newItem, itemAttribute: updatedAttributes });
  };

  return (
    <>
      <div className="page-location">
        <span>Inventory &gt; Add New Item</span>
      </div>
      <Container maxWidth="lg" sx={{ padding: 1 }}>
        {/* <h1 className="heading-add-item">Add New Item</h1> */}
        <span className="label-type">Type: </span>
        <div className="type-selection">
          <FormControl className="type-selection-row">
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue="Goods"
              name="radio-buttons-group"
              value={newItem.type}
              onChange={(e) => {
                if (
                  e.target.value === "Goods" ||
                  e.target.value === "Service"
                ) {
                  setNewItem({ ...newItem, type: e.target.value });
                } else {
                  console.error("Invalid type value");
                }
              }}
              row
            >
              <FormControlLabel
                value="Goods"
                control={<Radio />}
                label={LBL_TYPE_GOODS}
              />
              <FormControlLabel
                value="Service"
                control={<Radio />}
                label={LBL_TYPE_SERVICE}
              />
            </RadioGroup>
          </FormControl>

          <Tooltip title={LBL_TOOLTIP_HELP} arrow>
            <a href="/userguide.pdf" download>
              <img src="/icons8-help-94.png" alt="Help" className="help-link" />
            </a>
          </Tooltip>
        </div>
        <span className="label-type">{LBL_ITEM_TYPE}</span>
        <div className="type-selection">
          <FormControl className="type-selection-row">
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              name="itemType"
              value={newItem.itemType}
              onChange={(e) => {
                const itemType = e.target.value;
                if (itemType === "Inventory" || itemType === "NonInventory") {
                  setNewItem({ ...newItem, itemType });
                } else {
                  console.error(`Invalid item type: ${itemType}`);
                }
              }}
              row
            >
              <div className="radio-group-container">
                <FormControlLabel
                  value="Inventory"
                  control={<Radio />}
                  label={LBL_ITEM_TYPE_INVENTORY}
                />
                <FormControlLabel
                  value="NonInventory"
                  control={<Radio />}
                  label={LBL_ITEM_TYPE_NONINVENTORY}
                />
              </div>
            </RadioGroup>
          </FormControl>
        </div>

        <div className="form-add-item">
          <div className="form-column">
            <TextField
              className="input-item-name"
              label={LBL_ITEM_NAME}
              required
              variant="outlined"
              value={newItem.name}
              onChange={(e) => {
                setNewItem({ ...newItem, name: e.target.value });
                if (e.target.value) {
                  setItemNameError(false);
                }
              }}
              onBlur={() => {
                if (!newItem.name) {
                  setItemNameError(true);
                }
              }}
              error={itemNameError}
              helperText={itemNameError ? MSG_ITEM_NAME_REQUIRED + "*" : ""}
              InputLabelProps={{
                style: { color: "black" },
              }}
            />
            <TextField
              className="input-hsn"
              label={LBL_HSN}
              //required
              variant="outlined"
              value={newItem.hsn}
              onChange={(e) => setNewItem({ ...newItem, hsn: e.target.value })}
            />
          </div>
          <div className="form-column">
            <TextField
              className="input-cost-price"
              label={LBL_COST_PRICE}
              type="number"
              variant="outlined"
              required
              value={newItem.costPrice}
              // onChange={(e) => {
              //   setNewItem({ ...newItem, costPrice: e.target.value });
              //   if (e.target.value) {
              //     setCostPriceError(false);
              //   }
              // }}
              onChange={(e) => {
                const value = Number(e.target.value);
                if (value >= 0) {
                  setNewItem({ ...newItem, costPrice: e.target.value });
                  if (e.target.value) {
                    setCostPriceError(false);
                  }
                } else {
                  // Swal.fire({
                  //   icon: "warning",
                  //   title: "Invalid Cost Price",
                  //   text: "Cost Price must be greater than or equalto zero.",
                  // });
                  enqueueSnackbar(MSG_COST_PRICE_MUST_BE_POSITIVE, {
                    variant: "warning",
                    autoHideDuration: 3000,
                  });
                }
              }}
              onBlur={() => {
                if (!newItem.name) {
                  setCostPriceError(true);
                }
              }}
              error={costPriceError}
              helperText={costPriceError ? MSG_COST_PRICE_REQUIRED + "*" : ""}
              InputLabelProps={{
                style: { color: "black" },
              }}
            />
            <TextField
              className="input-selling-price"
              label={LBL_SELLING_PRICE}
              type="number"
              variant="outlined"
              required
              value={newItem.sellingPrice}
              // onChange={(e) => {
              //   setNewItem({ ...newItem, sellingPrice: e.target.value });
              //   if (e.target.value) {
              //     setSellingPriceError(false);
              //   }
              // }}
              onChange={(e) => {
                const value = Number(e.target.value);
                if (value >= 0) {
                  setNewItem({ ...newItem, sellingPrice: e.target.value });
                  if (e.target.value) {
                    setSellingPriceError(false);
                  }
                } else {
                  // Swal.fire({
                  //   icon: "warning",
                  //   title: "Invalid Selling Price",
                  //   text: "Selling Price must be greater than or equalto zero.",
                  // });
                  enqueueSnackbar(MSG_SELLING_PRICE_MUST_BE_POSITIVE, {
                    variant: "warning",
                    autoHideDuration: 3000,
                  });
                }
              }}
              onBlur={() => {
                if (!newItem.name) {
                  setSellingPriceError(true);
                }
              }}
              error={sellingPriceError}
              helperText={sellingPriceError ? MSG_SELLING_PRICE_REQUIRED : ""}
              InputLabelProps={{
                style: { color: "black" },
              }}
            />
          </div>
          <div className="form-column">
            <div className="dropdown-column">
              <Select
                className="input-hsn"
                options={uomOptions}
                value={
                  uomOptions.find((option) => option.value === newItem.uom) ||
                  null
                }
                onChange={(selectedOption) => {
                  setNewItem({ ...newItem, uom: selectedOption?.value || "" });
                  if (selectedOption) {
                    setUomError(false);
                  }
                }}
                onBlur={() => {
                  if (!newItem.uom) {
                    setUomError(true);
                  }
                }}
                placeholder={
                  <span style={{ color: "black" }}>
                    {PLACEHOLDER_SELECT_UOM}
                  </span>
                }
                isSearchable
                isClearable={false}
                menuPortalTarget={document.body}
                styles={{
                  menu: (base) => ({
                    ...base,
                    zIndex: 1000, // Override the default z-index
                  }),
                  control: (base, state) => ({
                    ...base,
                    borderColor: uomError ? "red" : base.borderColor, // Highlight red on error
                    "&:hover": {
                      borderColor: uomError ? "red" : base.borderColor,
                    },
                  }),
                }}
              />
              {uomError && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  {MSG_UOM_REQUIRED}
                </span>
              )}
            </div>
            <TextField
              className="input-hsn"
              label={LBL_STOCK_QUANTITY}
              type="number"
              variant="outlined"
              required
              value={newItem.quantity}
              // onChange={(e) => {
              //   setNewItem({ ...newItem, quantity: Number(e.target.value) });
              //   if (e.target.value) {
              //     setQuantityError(false);
              //   }
              // }}
              onChange={(e) => {
                const value = Number(e.target.value);
                if (value >= 0) {
                  setNewItem({ ...newItem, quantity: Number(e.target.value) });
                  if (e.target.value) {
                    setQuantityError(false);
                  }
                } else {
                  // Swal.fire({
                  //   icon: "warning",
                  //   title: "Invalid Stock Quantity",
                  //   text: "Stock Quantity must be greater than or equalto zero.",
                  // });
                  enqueueSnackbar(MSG_STOCK_QUANTITY_MUST_BE_POSITIVE, {
                    variant: "warning",
                    autoHideDuration: 3000,
                  });
                }
              }}
              onBlur={() => {
                if (!newItem.name) {
                  setQuantityError(true);
                }
              }}
              error={quantityError}
              helperText={
                quantityError ? MSG_STOCK_QUANTITY_REQUIRED + "*" : ""
              }
              InputLabelProps={{
                style: { color: "black" },
              }}
            />
          </div>
          <div className="form-column">
            <TextareaAutosize
              className="textarea-desc"
              placeholder={LBL_DESCRIPTION}
              value={newItem.desc}
              onChange={(e) => setNewItem({ ...newItem, desc: e.target.value })}
              minRows={4}
              maxRows={60}
              style={{ width: "49%" }}
            />
          </div>

          <Button
            onClick={() =>
              setNewItem({
                ...newItem,
                additionalFieldsOpen: !newItem.additionalFieldsOpen,
              })
            }
            variant="contained"
            sx={{
              background:
                "linear-gradient(45deg,rgb(68, 123, 187),rgb(15, 133, 236))",
              color: "#fff",
              width: "100%",
              maxWidth: "200px",
              padding: "1px 20px",
              borderRadius: "8px",
              transition: "all 0.3s ease-in-out",
              fontWeight: "bold",
              textTransform: "none",
              textAlign: "center",
              display: "block",
              margin: "0 auto", // Align button to the center
              height: "40px",
              "&:hover": {
                background:
                  "linear-gradient(45deg,rgb(64, 119, 182),rgb(55, 146, 226))",
                transform: "scale(1.05)",
              },
              "&:active": {
                transform: "scale(0.98)",
              },
            }}
            endIcon={
              <ExpandMore
                style={{
                  transform: newItem.additionalFieldsOpen
                    ? "rotate(180deg)"
                    : "rotate(0deg)",
                  transition: "transform 0.3s ease-in-out",
                }}
              />
            }
          >
            {LBL_OTHER_DETAILS}
          </Button>

          <Collapse in={newItem.additionalFieldsOpen}>
            <div className="form-add-item">
              <div className="form-column">
                <TextField
                  className="input-reorder-point"
                  label={LBL_REORDER_POINT}
                  type="number"
                  variant="outlined"
                  //required
                  value={newItem.reorderPoint}
                  // onChange={(e) =>
                  //   setNewItem({ ...newItem, reorderPoint: e.target.value })
                  // }
                  onChange={(e) => {
                    const value = Number(e.target.value);
                    if (value >= 0) {
                      setNewItem({ ...newItem, reorderPoint: e.target.value });
                    } else {
                      // Swal.fire({
                      //   icon: "warning",
                      //   title: "Invalid Reorder Point",
                      //   text: "Reorder Point must be greater than or equalto zero.",
                      // });
                      enqueueSnackbar(MSG_REORDER_POINT_MUST_BE_POSITIVE, {
                        variant: "warning",
                        autoHideDuration: 3000,
                      });
                    }
                  }}
                />
                <TextField
                  className="input-hsn"
                  label={LBL_WAREHOUSE}
                  variant="outlined"
                  //required
                  value={newItem.warehouse}
                  onChange={(e) =>
                    setNewItem({ ...newItem, warehouse: e.target.value })
                  }
                />
              </div>
              <div className="form-column">
                <TextField
                  className="input-sku"
                  label={LBL_SKU}
                  variant="outlined"
                  value={newItem.sku}
                  onChange={(e) =>
                    setNewItem({ ...newItem, sku: e.target.value })
                  }
                />
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    className="input-hsn"
                    label={LBL_EXPIRY_DATE}
                    minDate={dayjs()}
                    onChange={(newValue) =>
                      setNewItem({
                        ...newItem,
                        expiryDate: newValue
                          ? newValue.format("YYYY-MM-DD")
                          : "", // ✅ Send empty string if no date selected
                      })
                    }
                  />
                </LocalizationProvider>
                {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        className="input-hsn"
        label="Expiry Date"
        onChange={(newValue) =>
          setNewItem({
            ...newItem,
            expiryDate: newValue ? newValue.format("DDTHH-MM-YYYY:mm:ss.SSSZ") : "",
          })
        }
      />{" "}
    </LocalizationProvider> */}
              </div>
              <div className="form-column">
                <TextField
                  className="input-upc"
                  label={LBL_UPC}
                  variant="outlined"
                  value={newItem.upc}
                  onChange={(e) =>
                    setNewItem({ ...newItem, upc: e.target.value })
                  }
                />
                <TextField
                  className="input-ian"
                  label="IAN"
                  variant="outlined"
                  value={newItem.ian}
                  onChange={(e) =>
                    setNewItem({ ...newItem, ian: e.target.value })
                  }
                />
              </div>
              <div className="form-column">
                <TextField
                  className="input-hsn"
                  label={LBL_BATCH_NUMBER}
                  type="number"
                  variant="outlined"
                  value={newItem.batchNumber}
                  // onChange={(e) =>
                  //   setNewItem({
                  //     ...newItem,
                  //     batchNumber: Number(e.target.value),
                  //   })
                  // }
                  onChange={(e) => {
                    const value = Number(e.target.value);
                    if (value >= 0) {
                      setNewItem({
                        ...newItem,
                        batchNumber: Number(e.target.value),
                      });
                    } else {
                      // Swal.fire({
                      //   icon: "warning",
                      //   title: "Invalid Batch Number",
                      //   text: "Batch Number must be greater than or equalto zero.",
                      // });
                      enqueueSnackbar(MSG_BATCH_NUMBER_MUST_BE_POSITIVE, {
                        variant: "warning",
                        autoHideDuration: 3000,
                      });
                    }
                  }}
                />
                <TextField
                  className="input-hsn"
                  label={LBL_LOT_NUMBER}
                  type="number"
                  variant="outlined"
                  value={newItem.lotNumber}
                  // onChange={(e) =>
                  //   setNewItem({
                  //     ...newItem,
                  //     lotNumber: Number(e.target.value),
                  //   })
                  // }
                  onChange={(e) => {
                    const value = Number(e.target.value);
                    if (value >= 0) {
                      setNewItem({
                        ...newItem,
                        lotNumber: Number(e.target.value),
                      });
                    } else {
                      // Swal.fire({
                      //   icon: "warning",
                      //   title: "Invalid Lot Number",
                      //   text: "Lot Number must be greater than or equalto zero.",
                      // });
                      enqueueSnackbar(MSG_LOT_NUMBER_MUST_BE_POSITIVE, {
                        variant: "warning",
                        autoHideDuration: 3000,
                      });
                    }
                  }}
                />
              </div>
              <div className="form-column" style={{ marginBottom: "2rem" }}>
                <TextField
                  className="input-discount"
                  label={LBL_DISCOUNT_RATE}
                  type="number"
                  variant="outlined"
                  style={{ width: "49%" }}
                  value={newItem.discountRate}
                  // onChange={(e) =>
                  //   setNewItem({
                  //     ...newItem,
                  //     discountRate: Number(e.target.value),
                  //   })
                  // }
                  onChange={(e) => {
                    const value = Number(e.target.value);
                    if (value >= 0) {
                      setNewItem({
                        ...newItem,
                        discountRate: Number(e.target.value),
                      });
                    } else {
                      // Swal.fire({
                      //   icon: "warning",
                      //   title: "Invalid Discount Rate",
                      //   text: "Discount Rate must be greater than or equalto zero.",
                      // });
                      enqueueSnackbar(MSG_DISCOUNT_RATE_MUST_BE_POSITIVE, {
                        variant: "warning",
                        autoHideDuration: 3000,
                      });
                    }
                  }}
                />
                <div className="type-selection">
                  <span className="label-type">{LBL_TAX_PREFERENCE}: </span>
                  <RadioGroup
                    row
                    aria-labelledby="tax-preference-radio-buttons-group-label"
                    name="taxPreference"
                    value={newItem.taxable ? "Taxable" : "Non-Taxable"}
                    onChange={handleTaxableChange}
                  >
                    <div className="radio-group-container">
                      <FormControlLabel
                        value="Taxable"
                        control={<Radio />}
                        label={LBL_TAXABLE}
                      />
                      <FormControlLabel
                        value="Non-Taxable"
                        control={<Radio />}
                        label={LBL_NON_TAXABLE}
                      />
                    </div>
                  </RadioGroup>
                </div>
              </div>
            </div>
          </Collapse>
        </div>

        <div className="form-add-item">
          <div className="form-row-dropdown">
            {/* Category Dropdown */}
            <div className="dropdown-column">
              <Select
                className="dropdown-field"
                options={categoryOptions}
                value={
                  categoryOptions.find(
                    (option) => option.id === newItem.categoryId
                  ) || null
                }
                onChange={(selectedOption) =>
                  handleCategoryBrandManufacturerChange(
                    "category",
                    selectedOption
                  )
                }
                onBlur={() => {
                  if (!newItem.categoryId) {
                    setErrors((prev) => ({ ...prev, category: true }));
                  }
                }}
                placeholder={PLACEHOLDER_SELECT_CATEGORY}
                isSearchable
                styles={{
                  control: (base) => ({
                    ...base,
                    borderColor: errors.category ? "red" : base.borderColor,
                  }),
                }}
              />
              {errors.category && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  {MSG_CATEGORY_REQUIRED}*
                </span>
              )}
            </div>

            {/* Brand Dropdown */}
            <div className="dropdown-column">
              <Select
                className="dropdown-field"
                options={brandOptions}
                value={
                  brandOptions.find(
                    (option) => option.id === newItem.brandId
                  ) || null
                }
                onChange={(selectedOption) =>
                  handleCategoryBrandManufacturerChange("brand", selectedOption)
                }
                // onBlur={() => {
                //   if (!newItem.brandId) {
                //     setErrors((prev) => ({ ...prev, brand: true }));
                //   }
                // }}
                placeholder={PLACEHOLDER_SELECT_BRAND}
                isSearchable
                styles={{
                  control: (base) => ({
                    ...base,
                    borderColor: errors.brand ? "red" : base.borderColor,
                  }),
                }}
              />
              {errors.brand && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  {MSG_BRAND_REQUIRED}*
                </span>
              )}
            </div>

            {/* Manufacturer Dropdown */}
            <div className="dropdown-column">
              <Select
                className="dropdown-field"
                options={manufacturerOptions}
                value={
                  manufacturerOptions.find(
                    (option) => option.id === newItem.manufacturerId
                  ) || null
                }
                onChange={(selectedOption) =>
                  handleCategoryBrandManufacturerChange(
                    "manufacturer",
                    selectedOption
                  )
                }
                // onBlur={() => {
                //   if (!newItem.manufacturerId) {
                //     setErrors((prev) => ({ ...prev, manufacturer: true }));
                //   }
                // }}
                placeholder={PLACEHOLDER_SELECT_MANUFACTURER}
                isSearchable
                styles={{
                  control: (base) => ({
                    ...base,
                    borderColor: errors.manufacturer ? "red" : base.borderColor,
                  }),
                }}
              />
              {errors.manufacturer && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  {MSG_MANUFACTURER_REQUIRED}*
                </span>
              )}
            </div>
          </div>

          {/* Multiple Items Checkbox */}
          <div className="type-selection">
            <span className="label-type">Multiple Items: </span>
            <FormControlLabel
              control={
                <Checkbox
                  checked={newItem.createAttributes}
                  onChange={(e) => {
                    const checked = e.target.checked;

                    // State update using callback function to ensure proper update
                    setNewItem((prevState) => ({
                      ...prevState,
                      createAttributes: checked,
                    }));
                    //handleAddAttribute();

                    // Ensuring `handleAttributesChange` runs after state update
                    setTimeout(() => {
                      handleAttributesChange(e);

                      if (checked && newItem.itemAttribute.length === 0) {
                        handleAddAttribute();
                      }
                    }, 0);
                  }}
                />
              }
              label={LBL_CREATE_ATTRIBUTES}
            />
          </div>
          {newItem.createAttributes && (
            <div className="attributes-options">
              {newItem.itemAttribute.map((attribute, idx) => (
                <div key={idx} className="attribute-section">
                  <div className="attribute-field">
                    <Select
                      className="dropdown-field"
                      value={
                        attribute.attribute
                          ? {
                              value: attribute.attribute,
                              label:
                                availableAttributes.find(
                                  (a) => a.id === attribute.attribute
                                )?.name || "Select Attribute Name",
                            }
                          : null
                      }
                      options={availableAttributes.map((attr) => ({
                        value: attr.id,
                        label: attr.name || "", // Fallback to an empty string if `name` is undefined
                      }))}
                      onChange={(selectedOption) =>
                        handleAttributeOptionChange(
                          idx,
                          "attribute",
                          selectedOption
                        )
                      }
                      placeholder={PLACEHOLDER_SELECT_ATTRIBUTE_NAME}
                      isSearchable
                    />
                  </div>
                  <div className="attribute-field">
                    <Select
                      className="dropdown-field"
                      options={(attribute.availableOptions || []) // Use row-specific options
                        .map((attr) => ({
                          value: attr.id,
                          label: attr.name,
                        }))}
                      value={
                        attribute.option
                          ? {
                              value: attribute.option,
                              label:
                                attribute.availableOptions?.find(
                                  (o) => o.id === attribute.option
                                )?.name || "",
                            }
                          : null
                      }
                      onChange={(selectedOption) =>
                        handleAttributeOptionChange(
                          idx,
                          "option",
                          selectedOption
                        )
                      }
                      placeholder={PLACEHOLDER_SELECT_OPTIONS}
                      isSearchable
                    />
                    {/* <Select
                      className="dropdown-field"
                      options={availableAttributesOption
                        .filter((attr) => attr.name) // Exclude options with undefined names
                        .map((attr) => ({
                          value: attr.id,
                          label: attr.name,
                        }))}
                      value={
                        attribute.option
                          ? {
                              value: attribute.option,
                              label:
                                availableAttributesOption.find(
                                  (o) => o.id === attribute.option
                                )?.name || "",
                            }
                          : null
                      }
                      onChange={(selectedOption) =>
                        handleAttributeOptionChange(
                          idx,
                          "option",
                          selectedOption
                        )
                      }
                      placeholder="Select Options"
                      isSearchable
                    /> */}
                  </div>
                  {/* <button className="remove-button" onClick={() => handleRemoveAttributeOption(idx)}>
                      Remove
                    </button> */}
                  <img
                    className="remove-icon"
                    src="/icons8-delete-94.png"
                    alt="Remove"
                    onClick={() => handleRemoveAttributeOption(idx)}
                  />
                </div>
              ))}
              <button
                style={{ float: "right", marginRight: "50px" }}
                className="add-attribute"
                onClick={handleAddAttribute}
              >
                {LBL_ADD_ATTRIBUTE}
              </button>
            </div>
          )}
          {/* <button className="btn-add-item" onClick={handleAddItem}>
            Add Item
          </button> */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Button
              className="btn-add-item"
              variant="contained"
              onClick={handleAddItem}
              disabled={saving}
            >
              {/* {saving ? "Saving..." : "Save"} */}
              {saving ? (
                <CircularProgress size={20} color="inherit" />
              ) : (
                LBL_ADD_ITEM
              )}
            </Button>
          </Box>
        </div>
      </Container>
      <Box
        sx={{
          position: "relative",
          left: 0,
          bottom: 0,
          width: "100%",
        }}
      >
        <Footer />
      </Box>
    </>
  );
};

export default AddItemModal;
